/**
 * Начальное состояние store-модуля карточки заявки
 */
export default function () {
    return {
        // Данные заявки (null до загрузки)
        request: null,
        originalRequest: null,
        
        // Активность заявки (комментарии и история)
        requestActivity: [],
        
        // Доступные действия для текущего пользователя
        availableActions: [],
        
        // Доступные исполнители для ручного назначения
        availableExecutors: [],

        // UI-переключатель админской проекции прав в карточке заявки
        adminGodModeEnabled: false,
        
        // Флаги загрузки
        loading: false,
        savingRequest: false,
        uploadingRequiredAttachment: false,
        submittingRequest: false,
        approvingRequest: false,
        rejectingRequest: false,
        executingRequest: false,
        returningRequest: false,
        completingRequest: false,
        partiallyCompletingRequest: false,
        acceptingRequest: false,
        acceptingPartiallyRequest: false,
        cancellingRequest: false,
        changingStatus: false,
        assigningExecutor: false,
        downloadingMaterials: false,
        
        // Выбранный исполнитель
        selectedExecutorId: null,
        
        // Новые файлы для загрузки
        newAttachments: [],
        attachmentsInputValue: null,
        removedFileIds: [],
        
        // Изменения материалов
        materialsChanges: {
            added: [],
            updated: [],
            deleted: []
        },
        isEditingMaterialsList: false,
        materialsSaveRevision: 0,
        
        // Автосохранение черновиков
        autoSaveTimer: null,
        lastAutoSaveTime: null
    };
}
